import Vue from 'vue';

const COOKIE_NAME = 'rm_cookie_consent';
const POLICY_VERSION = 3;
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 12 months

const CATEGORIES = ['analytics'];

function readFromStorage() {
    try {
        const match = document.cookie.match(
            new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)')
        );
        if (!match) return null;
        const parsed = JSON.parse(decodeURIComponent(match[1]));
        if (!parsed || parsed.version !== POLICY_VERSION) return null;
        return parsed;
    } catch (e) {
        return null;
    }
}

function writeToStorage(value) {
    try {
        const secure = location.protocol === 'https:' ? '; Secure' : '';
        document.cookie =
            COOKIE_NAME +
            '=' +
            encodeURIComponent(JSON.stringify(value)) +
            '; Path=/; Max-Age=' +
            MAX_AGE_SECONDS +
            '; SameSite=Lax' +
            secure;
        return true;
    } catch (e) {
        return false;
    }
}

const state = Vue.observable({
    consent: readFromStorage(),
});

const listeners = [];

export default {
    POLICY_VERSION,

    getConsent() {
        return state.consent;
    },

    hasValidConsent() {
        return !!state.consent;
    },

    setConsent(choices) {
        const prev = state.consent;
        const next = {
            version: POLICY_VERSION,
            necessary: true,
            timestamp: new Date().toISOString(),
        };
        CATEGORIES.forEach((c) => { next[c] = !!(choices && choices[c]); });
        writeToStorage(next);
        state.consent = next;
        listeners.forEach((cb) => {
            try { cb(next, prev); } catch (e) { /* ignore listener errors */ }
        });
        return next;
    },

    CATEGORIES,

    onConsentChange(cb) {
        listeners.push(cb);
        return () => {
            const idx = listeners.indexOf(cb);
            if (idx >= 0) listeners.splice(idx, 1);
        };
    },
};
